import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generalRoutes } from '../../../common/routes/general';
function SignInBanner() {
    return (_jsxs("div", { className: "alert alert-info d-flex align-items-center gap-2 mb-0", children: [_jsx("i", { className: "bi bi-info-circle" }), _jsxs("span", { children: [_jsx("a", { href: generalRoutes.login.getURL(), className: "fw-semibold text-decoration-none", children: "Sign in" }), ' ', "to join the conversation, post new discussions, and comment."] })] }));
}
export default SignInBanner;
